var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62 12.5467C9.49333 12.5467 9.36667 12.5001 9.26667 12.4001C9.07333 12.2067 9.07333 11.8867 9.26667 11.6934L12.96 8.00008L9.26667 4.30674C9.07333 4.11341 9.07333 3.79341 9.26667 3.60008C9.46 3.40674 9.78 3.40674 9.97333 3.60008L14.02 7.64675C14.2133 7.84008 14.2133 8.16008 14.02 8.35341L9.97333 12.4001C9.87333 12.5001 9.74667 12.5467 9.62 12.5467Z",
    fill: "#6F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5533 8.5H2.33333C2.06 8.5 1.83333 8.27333 1.83333 8C1.83333 7.72667 2.06 7.5 2.33333 7.5H13.5533C13.8267 7.5 14.0533 7.72667 14.0533 8C14.0533 8.27333 13.8267 8.5 13.5533 8.5Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.daa016d6e140e523144c8614e3561081.svg";
export { ForwardRef as ReactComponent };